import React from 'react'

import { StyleboardGroupItem } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils' // REMOVE
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import appSelectors from 'App/duck/selectors'
import { StyleboardItemProps } from 'features/favourites/components/Stylehub/components/MyStyleboards/types'
import { StyleboardStatus } from 'features/Styleboard/types'

const StyleboardItem: React.FC<StyleboardItemProps> = ({
  styleboard,
  shouldShowGreenCheckbox,
  shouldShowCheckbox,
  onQuickFollow,
}) => {
  const history = useHistory()
  const isSmallScreen = useSelector(appSelectors.getIsSmallScreen)

  const onQuickFollowHanlder = (styleboardId: string): void => {
    if (onQuickFollow) {
      onQuickFollow(styleboardId)
    }
  }

  const { image, status, title, totalNoItems, followers, id, author, updated } = styleboard

  const styleboardTotalItemsLabel =
    totalNoItems === 1 ? 'styleboard.item.count.single' : 'styleboard.item.count'

  const subHeading = `${getLabelFromStorage(styleboardTotalItemsLabel, {
    replacements: totalNoItems || 0,
  })} | ${getLabelFromStorage('styleboard.followers.count', {
    replacements: followers || 0,
  })}`

  const action = shouldShowCheckbox
    ? {
        showIndicator: true,
      }
    : {
        showUpdated: updated,
      }

  return (
    <StyleboardGroupItem
      key={id}
      id={id}
      Tag="button"
      images={[{ id: title, src: image }]}
      imageAltText="" // TODO: add label when received
      privateStyleboard={status === StyleboardStatus.PRIVATE}
      heading={title}
      createdByText={author.userName}
      subHeading={subHeading}
      onStyleboardGroupItemClick={() => {
        history.push(`/styleboard/${id}`)
      }}
      action={action}
      orientation={isSmallScreen ? 'landscape' : 'portrait'}
      privateText={getLabelFromStorage('styleboard.private')}
      shouldShowPrivateText={status === StyleboardStatus.PRIVATE}
      onCheckboxInputChange={() => onQuickFollowHanlder(id)}
      shouldShowGreenCheckbox={shouldShowGreenCheckbox}
    />
  )
}

export default StyleboardItem
